"use strict";
/*
 * Created on 27.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SessionFlag_1 = require("../model/SessionFlag");

var SessionInfo_1 = require("../model/SessionInfo");

var SessionInfoConverter_1 = require("./SessionInfoConverter");
/**
 * @author MSu
 */


var SessionInfoConverterImpl =
/*#__PURE__*/
function (_SessionInfoConverter) {
  _inherits(SessionInfoConverterImpl, _SessionInfoConverter);

  function SessionInfoConverterImpl() {
    _classCallCheck(this, SessionInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionInfoConverterImpl).apply(this, arguments));
  }

  _createClass(SessionInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SessionInfo_1.SessionInfo(conversions.documentToClassId(source), source.userId, conversions.toClassReferenceId(source.entityId), source.lastSimulationLoad !== null ? conversions.toDate(source.lastSimulationLoad) : null, conversions.asFlagSet(source.flags, SessionFlag_1.SessionFlag), conversions.toDate(source.created));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        userId: source.userId,
        entityId: conversions.toDocumentReferenceId(source.entityId),
        lastSimulationLoad: source.lastSimulationLoad !== null ? conversions.fromDate(source.lastSimulationLoad) : null,
        flags: source.flags.serialize(),
        created: conversions.fromDate(source.created)
      });
      return result;
    }
  }]);

  return SessionInfoConverterImpl;
}(SessionInfoConverter_1.SessionInfoConverter);

exports.SessionInfoConverterImpl = SessionInfoConverterImpl;